import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISetUpState } from '../../app/set-up/set-up.types';

const initialSetUpState: ISetUpState = { step: 'connector' };

const setupModalSlice = createSlice({
    name: 'setupModal',
    initialState: initialSetUpState,
    reducers: {
        setSetupModal: (state, action: PayloadAction<Partial<ISetUpState>>) => {
            Object.entries(action.payload).forEach(([key, value]) => {
                if (value !== undefined) {
                    (state as any)[key] = value;
                }
            });
        },
        clearSetupModal: () => initialSetUpState,
    },
});

export const { setSetupModal, clearSetupModal } = setupModalSlice.actions;
export const setupModalReducer = setupModalSlice.reducer;
